import app from 'flarum/common/app';

app.initializers.add('foskym/nickname-group-formatter', () => {

});
